"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchAllUsersQuery = exports.fetchMeQuery = exports.verifyEmailMutation = exports.updateUserMutation = exports.updatePassword = exports.recoveryPassword = exports.createUserMutation = exports.signInMutation = exports.userResponseFragment = exports.userOrganizationsFragment = exports.userFragment = exports.tokenDataFragment = exports.contactFragment = void 0;
const tslib_1 = require("tslib");
const Contact_graphql_1 = tslib_1.__importDefault(require("./fragments/Contact.graphql"));
exports.contactFragment = Contact_graphql_1.default;
const TokenData_graphql_1 = tslib_1.__importDefault(require("./fragments/TokenData.graphql"));
exports.tokenDataFragment = TokenData_graphql_1.default;
const User_graphql_1 = tslib_1.__importDefault(require("./fragments/User.graphql"));
exports.userFragment = User_graphql_1.default;
const UserOrganizations_graphql_1 = tslib_1.__importDefault(require("./fragments/UserOrganizations.graphql"));
exports.userOrganizationsFragment = UserOrganizations_graphql_1.default;
const UserResponse_graphql_1 = tslib_1.__importDefault(require("./fragments/UserResponse.graphql"));
exports.userResponseFragment = UserResponse_graphql_1.default;
const signIn_graphql_1 = tslib_1.__importDefault(require("./mutations/signIn.graphql"));
exports.signInMutation = signIn_graphql_1.default;
const createUser_graphql_1 = tslib_1.__importDefault(require("./mutations/createUser.graphql"));
exports.createUserMutation = createUser_graphql_1.default;
const recoveryPassword_graphql_1 = tslib_1.__importDefault(require("./mutations/recoveryPassword.graphql"));
exports.recoveryPassword = recoveryPassword_graphql_1.default;
const updatePassword_graphql_1 = tslib_1.__importDefault(require("./mutations/updatePassword.graphql"));
exports.updatePassword = updatePassword_graphql_1.default;
const updateUser_graphql_1 = tslib_1.__importDefault(require("./mutations/updateUser.graphql"));
exports.updateUserMutation = updateUser_graphql_1.default;
const verifyEmail_graphql_1 = tslib_1.__importDefault(require("./mutations/verifyEmail.graphql"));
exports.verifyEmailMutation = verifyEmail_graphql_1.default;
const fetchMe_graphql_1 = tslib_1.__importDefault(require("./queries/fetchMe.graphql"));
exports.fetchMeQuery = fetchMe_graphql_1.default;
const fetchUsers_graphql_1 = tslib_1.__importDefault(require("./queries/fetchUsers.graphql"));
exports.searchAllUsersQuery = fetchUsers_graphql_1.default;
//# sourceMappingURL=index.js.map